import React, { useState } from 'react';
import { Stack, TextField, Button, Typography, MenuItem } from '@mui/material';
import { useApi } from '../context/useApi';
import { useTranslation } from 'react-i18next';
import { useMessage } from '../context/useMessage';

interface Props {
  closeDialog: () => void;
}

const CreateUserDialog = ({ closeDialog }: Props) => {
  const { defaultApi } = useApi();
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [role, setRole] = useState<"USER" | "ADMIN">("USER");
  const [loading, setLoading] = useState(false);
  const { success, error } = useMessage();

  const handleSubmit = async () => {
    setLoading(true);
    await defaultApi
      .userCreatePost({ data: { email, role } })
      .then((resp) => {
        if (resp.status === 200) {
          success({ message: t('success.creationUser') });
        }
        closeDialog();
      })
      .catch(() => {
        error({ message: t('error.userCreation') });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Stack
      spacing={2}
      paddingX={'20px'}
      paddingY={'50px'}
      sx={{ minWidth: '500px' }}
      alignItems={'center'}
    >
      <Typography variant="h6">{t('actions.createUser')}</Typography>

      <TextField label="email" value={email} onChange={(e) => setEmail(e.target.value)} fullWidth />
      <TextField select fullWidth value={role} label={t('user.role')} onChange={(e) => {
        setRole(e.target.value as "USER" | "ADMIN")
      }}>
        <MenuItem value={"USER"}>{t('user.user')}</MenuItem>
        <MenuItem value={"ADMIN"}>{t('user.admin')}</MenuItem>
      </TextField>
      <Stack>
        <Button variant="contained" onClick={handleSubmit} disabled={loading || !email}>
          {loading ? 'Creazione...' : 'Crea'}
        </Button>
      </Stack>
    </Stack>
  );
};

export default CreateUserDialog;
